var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3607 9.64625L8.3607 4.64625C8.40714 4.59976 8.46228 4.56288 8.52298 4.53772C8.58368 4.51256 8.64874 4.49961 8.71445 4.49961C8.78016 4.49961 8.84522 4.51256 8.90592 4.53772C8.96662 4.56288 9.02176 4.59976 9.0682 4.64625L14.0682 9.64625C14.1382 9.71618 14.1859 9.8053 14.2052 9.90235C14.2245 9.99939 14.2146 10.1 14.1768 10.1914C14.1389 10.2828 14.0747 10.3609 13.9924 10.4159C13.9101 10.4708 13.8134 10.5001 13.7144 10.5L3.71445 10.5C3.6155 10.5001 3.51875 10.4708 3.43646 10.4159C3.35416 10.3609 3.29001 10.2828 3.25214 10.1914C3.21426 10.1 3.20436 9.99939 3.22368 9.90235C3.24301 9.8053 3.29069 9.71618 3.3607 9.64625Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.3ede516c2b20bb3ce2012251f4eea8ff.svg";
export { ForwardRef as ReactComponent };